export default "<div class=\"row\">\n  <div class=\"column\">\n    <canvas #canvas height=\"400px\" width=\"400px\" id=\"barchart\"></canvas>\n  </div>\n</div>"